const photoModules = import.meta.glob('./img-*.{jpg,png}', { eager: true, import: 'default' }) as Record<string, string>;
import floorplan1 from './img-2.png';
import floorplan2 from './img-21.png';

const floorPlanFiles = new Set(['./img-2.png', './img-21.png']);

const sorted = Object.entries(photoModules)
  .filter(([path]) => !floorPlanFiles.has(path))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const uhrineves3Images: string[] = sorted;

export const uhrineves3FloorPlans = [
  { image: floorplan1, label: "Půdorys domu" },
  { image: floorplan2, label: "Půdorys domu – varianta" },
];
